<header id="header" class="header d-flex align-items-center fixed-top">
    <div class="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

      <a routerLink="/Home">
        <!-- Uncomment the line below if you also wish to use an image logo -->
        <img src="assets/img/logo.png" alt="Logo" style="width: auto;" height="70px" class="logo">
      </a>

     <nav id="navmenu" class="navmenu">
  <ul>
    <li (click)="mobileNavToggle()"><a routerLink="/Home" class="active">Startseite</a></li>
    <li (click)="mobileNavToggle()"><a routerLink="/About">Über uns</a></li>
    <li (click)="mobileNavToggle()"><a routerLink="/WhowItWork">So funktioniert's</a></li>
    <li (click)="mobileNavToggle()" class="dropdown"><a routerLink="/Jobs"><span>Jobs</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
      <ul>
        <li *ngFor="let catigory of categories" (click)="onCategoryClick($event, catigory)">
          <a [routerLink]="['/Jobs', catigory]">{{catigory}}</a>
        </li>
      </ul>
    </li>
     
    <li (click)="mobileNavToggle()"><a routerLink="/Courses">Kurse</a></li>
    <li (click)="mobileNavToggle()"><a routerLink="/Articles">Artikel</a></li>
    <li (click)="mobileNavToggle()"><a routerLink="/Contact">Kontakt</a></li>
    <li (click)="mobileNavToggle()"><a routerLink="/Privacy">Datenschutz</a></li>
    

 
  </ul>
</nav>
      <div class="d-flex align-items-center justify-content-between">
          <div class="d-none d-sm-block" *ngIf="!isLoggedIn">
          <button class="btn btn-primary rounded-pill me-3" data-bs-toggle="modal" data-bs-target="#loginModal">Anmelden</button>
          <button class="btn btn-outline-primary rounded-pill" data-bs-toggle="modal" data-bs-target="#signupModal">Registrieren</button>
        </div>
        <ul *ngIf="isLoggedIn" class="nav-item navbar-dropdown dropdown-user dropdown d-flex align-items-center" style="margin: 0; justify-content: center !important;" data-bs-auto-close="outside">
          <li class="nav-item dropdown lh-1 me-3 notification">
                  <a
                    class="nav-link dropdown-toggle position-relative"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fa-solid fa-bell"></i>
                    <span class="nb">
                      {{notificationCount}}
                    </span>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-end main-dropdown-menu" style="width: 300px;" data-bs-auto-close="outside">
                    <li><h6 class="dropdown-header" style="color: black !important;">Benachrichtigungen</h6></li>
                    <li *ngFor="let notification of notifications" [class.unread]="notification.status=='UNREAD'" class="p-3 m-3 rounded-2">
                        <a>
                          <div class="table-noti-info d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                              <div class="table-noti-icon">
                                <i [class]="sharedService.getNotificationIcon(notification.type)"></i>
                              </div>
                              <div class="table-noti-message ml-3">
                                <h6>
                                  <a href="javascript:void(0);">{{ notification.title }}</a>
                                </h6>
                                <!-- Display calculated time -->
                                <span class="message-time">{{ notification.timestamp.toDate() | date:'medium'}}</span>
                              </div>
                            </div>
                          </div>
                        </a>
                    </li>

                    <div class="alert alert-info" *ngIf="notifications.length ==0">
                      <i class="fa-solid fa-circle-info me-2"></i> Es gibt noch keine Benachrichtigungen
                    </div>
                    <li><hr class="dropdown-divider" *ngIf="notifications.length"></li>
                    <li *ngIf="notifications.length && isAdmin"><a class="dropdown-item text-center text-primary" [routerLink]="['/Admin/Notifications']" (click)="updateAllNotifications(userUid)">Alle anzeigen</a></li>
                    <li *ngIf="notifications.length && !isAdmin">
                        <a
                          class="dropdown-item text-center text-primary"
                          [routerLink]="['/Profile']"
                          [queryParams]="{ tab: 'notifications' }"
                          (click)="updateAllNotifications(userUid)"
                        >Alle anzeigen</a>
                      </li>
                  </ul>
          </li>

          <li style="width: 50px; display: flex; align-items: center; justify-content: center; margin-left: -30px;">
             <a class="profile-image nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                    <div class="avatar avatar-online">
                      <img [src]="userInfo.image" alt="Benutzerbild" class="w-px-40 h-auto rounded-circle" />
                    </div>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" href="#">
                        <div class="d-flex">
                          <div class="flex-shrink-0 me-3">
                            <div class="avatar avatar-online">
                              <img [src]="userInfo.image" alt="Benutzerbild" class="w-px-40 h-auto rounded-circle" style="width: 100% !important; height: 100% !important;" />
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <span class="fw-semibold d-block">{{userInfo.fullName}}</span>
                            <small class="text-muted">{{userInfo.email}}</small>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <div class="dropdown-divider"></div>
                    </li>
                    <li *ngIf="isAdmin ==true">
                      <a class="dropdown-item" routerLink="/Admin/Dashboard">
                        <i class="bx bx-user me-2"></i>
                        <span class="align-middle">Mein Profil</span>
                      </a>
                    </li>

                     <li *ngIf="isAdmin ==false">
                      <a class="dropdown-item" routerLink="/Profile">
                        <i class="bx bx-user me-2"></i>
                        <span class="align-middle">Mein Profil</span>
                      </a>
                    </li>
                    <li (click)="logOut()">
                      <a class="dropdown-item">
                        <i class="bx bx-power-off me-2"></i>
                        <span class="align-middle">Abmelden</span>
                      </a>
                    </li>
                  </ul>
          </li>
        </ul>

        <div class="mobile-nav-toggle d-xl-none bi bi-list" #mobileNavToggleBtn (click)="mobileNavToggle()"></div>
      </div>
    </div>
</header>
<div class="nav-bottom">
      <div class="container-fluid d-flex align-items-center justify-content-between">
        <div class="social-icons">
          <a [href]="account.url" class="icon" *ngFor="let account of socialMediaAccounts">
            <i class="{{ sharedService.getPlatformIcon(account.platform) }}"></i>
          </a>
        </div>
        <div class="" *ngIf="!isLoggedIn">
          <button class="btn btn-primary rounded-pill me-3" data-bs-toggle="modal" data-bs-target="#loginModal">Anmelden</button>
          <button class="btn btn-outline-primary rounded-pill" data-bs-toggle="modal" data-bs-target="#signupModal">Registrieren</button>
        </div>
      </div>
</div>
<!-- Login Modal -->
<div class="modal fade" id="loginModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body" style="margin-top: 0;">
        <h4 class="mb-2">Willkommen bei TowardsGermany! 👋</h4>
        <p class="mb-4">Bitte melden Sie sich an, um Ihr Abenteuer zu beginnen</p>

        <form #loginForm="ngForm" (ngSubmit)="login(loginForm)" novalidate>
          <!-- Email -->
          <div class="mb-3">
            <label for="loginEmail" class="form-label">E-Mail </label>
            <input type="text" id="loginEmail"
             name="email"
              class="form-control"
              required
              ngModel
              #email="ngModel"
              placeholder="Geben Sie Ihre E-Mail " />
            <div *ngIf="email.invalid && email.touched" class="text-danger small">
              E-Mail ist erforderlich.
            </div>
          </div>

          <!-- Password -->
          <div class="mb-3">
            <div class="d-flex justify-content-between">
                    <label class="form-label" for="password">Passwort</label>
                    <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#forgotPasswordModal">
                      <small>Passwort vergessen?</small>
                    </a>
            </div>
            <input type="password" id="loginPassword" name="password"
              class="form-control"
             ngModel
              required minlength="6"
              #password="ngModel"
              placeholder="********" />
            <div *ngIf="password.invalid && password.touched" class="text-danger small">
              Passwort ist erforderlich (mind. 6 Zeichen).
            </div>
          </div>

          <button type="submit" class="btn btn-primary w-100" [disabled]="loginForm.invalid" data-bs-dismiss="modal">Anmelden</button>
        </form>

        <p class="text-center mt-3">
          <span>Neu auf unserer Plattform? </span>
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#signupModal"> Konto erstellen</a>
        </p>
        <div class="d-flex align-items-center justify-content-center mt-1">
          <div class="line"></div>
          <p style="background-color: white; padding: 2px;">ODER</p>
          <div class="line"></div>
        </div>
        <div class="social-auth">
            <button (click)="loginWithGoogle()" data-bs-dismiss="modal" class="btn-social btn btn-google">
            <img src="assets/img/google-icon.png" alt="Google-Symbol">
            <span>Mit Google anmelden</span>
          </button>
          <button (click)="loginWithFacebook()" data-bs-dismiss="modal" class="btn-social btn btn-facebook">
            <i class="bi bi-facebook"></i>
            <span>Mit Facebook anmelden</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Signup Modal -->
<div class="modal fade" id="signupModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <h4 class="mb-2">Das Abenteuer beginnt hier 🚀</h4>
        <p class="mb-4">Machen Sie die Verwaltung Ihrer App einfach und unterhaltsam!</p>

        <form #signupForm="ngForm" (ngSubmit)="signup(signupForm)" novalidate>
          <div class="mb-3">
            <label for="signupUsername" class="form-label">Benutzername</label>
            <input type="text" id="signupUsername" name="fullName"
              class="form-control"
             ngModel
              required
              #fullName="ngModel"
              placeholder="Geben Sie Ihren Benutzernamen ein" />
            <div *ngIf="fullName.invalid && fullName.touched" class="text-danger small">
              Benutzername ist erforderlich.
            </div>
          </div>

          <div class="mb-3">
            <label for="signupEmail" class="form-label">E-Mail</label>
            <input type="email" id="signupEmail" name="email"
              class="form-control"
              ngModel
              required email
              #signupEmailField="ngModel"
              placeholder="Geben Sie Ihre E-Mail ein" />
            <div *ngIf="signupEmailField.invalid && signupEmailField.touched" class="text-danger small">
              Gültige E-Mail ist erforderlich.
            </div>
          </div>

          <div class="mb-3">
            <label for="signupPassword" class="form-label">Passwort</label>
            <input type="password" id="signupPassword" name="password"
              class="form-control"
              ngModel
              required minlength="6"
              #signupPasswordField="ngModel"
              placeholder="********" />
            <div *ngIf="signupPasswordField.invalid && signupPasswordField.touched" class="text-danger small">
              Passwort ist erforderlich (mind. 6 Zeichen).
            </div>
          </div>

          <button type="submit" class="btn btn-primary w-100" [disabled]="signupForm.invalid" data-bs-dismiss="modal">Registrieren</button>
        </form>

        <p class="text-center mt-3">
          <span>Bereits ein Konto? </span>
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#loginModal">Stattdessen anmelden</a>
        </p>

         <div class="d-flex align-items-center justify-content-center mt-1">
          <div class="line"></div>
          <p style="background-color: white; padding: 2px;">ODER</p>
          <div class="line"></div>
        </div>
        <div class="social-auth g-2">
          <button (click)="loginWithGoogle()" data-bs-dismiss="modal" class="btn-social btn btn-google">
          <img src="assets/img/google-icon.png" alt="Google-Symbol">
          <span>Mit Google anmelden</span>
        </button>
        <button (click)="loginWithFacebook()" data-bs-dismiss="modal" class="btn-social btn btn-facebook">
          <i class="bi bi-facebook"></i>
          <span>Mit Facebook anmelden</span>
        </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Forgot Password Modal -->
<div class="modal fade" id="forgotPasswordModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <h4 class="mb-2">Passwort vergessen? 🔒</h4>
        <p class="mb-4">Geben Sie Ihre E-Mail ein, und wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts</p>

        <form #forgotForm="ngForm" (ngSubmit)="restPassword(forgotForm)" novalidate>
          <div class="mb-3">
            <label for="forgotEmail" class="form-label">E-Mail</label>
            <input type="email" id="forgotEmail" name="email"
              class="form-control"
              ngModel
              required email
              #forgotEmailField="ngModel"
              placeholder="Geben Sie Ihre E-Mail ein" />
            <div *ngIf="forgotEmailField.invalid && forgotEmailField.touched" class="text-danger small">
              Gültige E-Mail ist erforderlich.
            </div>
          </div>
          <button type="submit" class="btn btn-primary w-100" [disabled]="forgotForm.invalid" data-bs-dismiss="modal">Link zum Zurücksetzen senden</button>
        </form>

        <div class="text-center mt-3">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#loginModal">
            Zurück zum Anmelden
          </a>
        </div>
      </div>
    </div>
  </div>
</div>